export const HOME_PATH = 'home';
export const HISTORY_PATH = 'activities';
export const INSIGHTS_PATH = 'insights';
export const TEAM_PATH = 'team';
export const LOGIN_PATH = 'login';
export const SETTINGS_PATH = 'settings';
export const PROFILE_PATH = 'profile';
export const CHANGE_PASSWORD_PATH = 'change-password';
export const REQUEST_PASSWORD_RESET_PATH = 'request-password-reset';
export const RESET_PASSWORD_PATH = 'reset-password';
export const CREATE_ACCOUNT_PATH = 'create-account';
export const PROFILE_ON_BOARDING_PATH = 'set-profile';

export const ActivityType = {
  OTHER: 'other',
  SPEAKING: 'speaking',
  VIDEO: 'video',
  PODCAST: 'podcast',
  LIVE_STREAM: 'livestream',
  WORKSHOP: 'workshop',
};

